import type { Direction } from "../direction";
import type { ParticleType } from "../particleType";
import type { XY } from "../xy";
import { XYEffect } from "./xyEffect";

export class ParticleEffect extends XYEffect {
	static key = "ParticleEffect";

	constructor(
		xy: XY,
		public readonly particleType: ParticleType,
		public readonly count: number,
		public readonly direction?: Direction,
	) {
		super(xy);
		this.setUnbounded(true);
	}
}
